export const DEFAULT_ASSIGNMENT_RULES = [
  'previous_contact_agent',
  'available_agent',
  'fair_rotation',
  'active_load',
  'resolved_conversations',
  'first_response_time',
];

export const getAssignmentRules = botConfig => {
  const configuredRules = botConfig?.assignment_rules || [];
  const fixedRules = DEFAULT_ASSIGNMENT_RULES.slice(0, 3);
  const weightedRules = DEFAULT_ASSIGNMENT_RULES.slice(3);
  const validRules = configuredRules.filter(
    (rule, index) =>
      weightedRules.includes(rule) && configuredRules.indexOf(rule) === index
  );

  return [
    ...fixedRules,
    ...validRules,
    ...weightedRules.filter(rule => !validRules.includes(rule)),
  ];
};
